export function getTitleForNoteType(noteType, translate) {
  switch (noteType) {
    case "endOfShift":
      return translate("EditEndOfShiftNote");
    case "familyNote":
      return translate("EditFamilyNote");
    case "groupNote":
      return translate("EditGroupNote");
    case "handoverNote":
      return translate("EditHandoverNote");
    case "medicalNote":
      return translate("EditMedicalNote");
    case "quickNote":
      return translate("EditQuickNote");
    case "therapyNote":
      return translate("EditTherapyNote");
    case "supportStaffNote":
      return translate("EditSupportStaffNote");
    case "aftercareNote":
      return translate("EditAftercareNote");
    default:
      return "Edit Note";
  }
}

export function getStylesForNoteType(noteType) {
  switch (noteType) {
    case "quickNote":
      return { backgroundColor: "#FFFACD", color: "orange" };
    case "handoverNote":
      return { backgroundColor: "#B0E0E6", color: "#4682B4" };
    case "therapyNote":
      return { backgroundColor: "#98FB98", color: "#2E8B57" };
    case "supportStaffNote":
      return { backgroundColor: "#FFC0CB", color: "#CD5C5C" };
    case "medicalNote":
      return { backgroundColor: "#FFDAB9", color: "#DB7093" };
    case "groupNote":
      return { backgroundColor: "#FFDAB9", color: "#FF4500" };
    case "familyNote":
      return { backgroundColor: "#FAFAD2", color: "#B8860B" };
    case "aftercareNote":
      return { backgroundColor: "#ADD8E6", color: "#4682B4" };
    case "endOfShift":
      return { backgroundColor: "#D3D3D3", color: "#696969" };
    default:
      return { backgroundColor: "white", color: "black" };
  }
}

export function formatCompactNoteType(noteType) {
  switch (noteType) {
    case "quickNote":
      return "QUICK NOTE";
    case "handoverNote":
      return "HANDOVER NOTE";
    case "therapyNote":
      return "THERAPY NOTE";
    case "supportStaffNote":
      return "SUP. STAFF NOTE";
    case "medicalNote":
      return "MEDICAL NOTE";
    case "groupNote":
      return "GROUP NOTE";
    case "familyNote":
      return "FAMILY NOTE";
    case "aftercareNote":
      return "AFTERCA. NOTE";
    case "endOfShift":
      return "END OF SHIFT";
    default:
      return noteType.toUpperCase();
  }
}
